// Mock content data for Coastal Growth Advisors site (mobyle.ai-style design)

export const BOOKING_URL =
  "https://calendly.com/sunil-coastalgrowthadvisors/30min?month=2026-04";

export const BRAND = {
  name: "Coastal Growth Advisors",
  shortName: "Coastal Growth",
  logo: "https://customer-assets.emergentagent.com/job_fe889f0f-f51e-4ae4-9496-4f2a622626be/artifacts/7167p3xi_Coastal%20Growth%20Advisors%20logo.png",
  tagline: "We don't generate traffic. We generate buyers.",
};

export const NAV_LINKS = [
  { label: "Solutions", href: "#solutions" },
  { label: "Features", href: "#features" },
  { label: "Case Studies", href: "#case-studies" },
];

export const HERO = {
  titleLine1: "Stop Stressing.",
  titleHighlight: "Start Targeting Buyers",
  titleLine2: "in Real Time.",
  subtitle:
    "We find people who are already searching for what you sell. Not cold audiences. Not \"maybe someday\" prospects. Not spray-and-pray ads.",
  primaryCTA: "Book a Strategy Call",
  secondaryCTA: "I Want My Own Data Platform",
};

export const SECTION_INTRO = {
  title: "We find People Who Are Already",
  titleHighlight: "Searching for What You Sell.",
  paragraphs: [
    'Not cold audiences. Not "maybe someday" prospects. Not spray-and-pray ads.',
    "We identify real people actively searching for your product or service — in real time — with up to 90% accuracy.",
    "Then we build the entire revenue engine around them.",
  ],
};

export const SYSTEM_OVERVIEW = {
  eyebrow: "The Complete",
  title: "AI Lead Generation System",
  body: [
    "Coastal Growth is more than a lead provider.",
    "It's a complete growth engine designed to deliver unlimited high-intent buyers in real time and convert them into customers automatically.",
    "With Coastal Growth, you get access to an entire AI-powered growth team and lead infrastructure in one platform.",
  ],
};

export const PILLARS = [
  {
    icon: "Target",
    title: "Unlimited High-Intent Buyer Identification",
    body: "Our AI analyzes billions of behavioral signals to identify people actively researching or shopping for what you sell — right now.",
    chips: ["No guessing.", "No cold audiences.", "Just real buyers."],
  },
  {
    icon: "Users",
    title: "Your Complete Growth Team Included",
    body: "Instead of hiring multiple agencies or specialists, Coastal Growth gives you access to a full expert team:",
    list: [
      "Custom Website & App Developers",
      "High-Performance Video Editors",
      "Automation Engineers",
      "Social Media Growth Experts",
      "SEO Specialists",
      "Paid Ads Strategists",
    ],
    footer: "All working together to build your ultimate lead engine.",
  },
  {
    icon: "Cpu",
    title: "Advanced AI-Powered Marketing Infrastructure",
    body: "Powered by Andromeda — Meta's latest AI model — and trained growth experts, Coastal Growth deploys a complete system designed to maximize conversions.",
    list: [
      "Advanced winning ad strategies (paid + retargeting)",
      "High-velocity creative testing with multiple hooks and angles",
      "Conversion-optimized landing pages",
      "Multichannel follow-up via SMS, email, voice drops, and WhatsApp",
      "AI callers and chatbots responding to leads in under 60 seconds",
      "No-show recovery sequences and 24-hour reactivation flows",
      "Automated pipeline management with win/loss tracking",
      "LinkedIn outreach system sending up to 200 targeted direct messages daily",
    ],
  },
];

export const RESULTS = [
  "More qualified leads",
  "More booked appointments",
  "More closed deals",
  "Lower cost per lead",
  "Predictable growth",
];

export const INTENT_SIGNALS = [
  { icon: "User", label: "Who is searching" },
  { icon: "Crosshair", label: "What they're searching for" },
  { icon: "Clock", label: "When they're searching" },
  { icon: "MapPin", label: "Where they are" },
  { icon: "Briefcase", label: "If they match your exact ICP" },
  { icon: "DollarSign", label: "Income & Credit profile" },
  { icon: "Building2", label: "Business profiles" },
  { icon: "BadgeDollarSign", label: "Company revenue" },
  { icon: "UsersRound", label: "Employee count" },
];

export const GROWTH_MACHINE = [
  {
    icon: "Crosshair",
    title: "Hyper-Targeted Ads",
    body: "Custom-built audiences powered by live intent data — not broad interest stacking.",
  },
  {
    icon: "LayoutTemplate",
    title: "Custom Sales Funnels",
    body: "High-converting landing pages engineered for YOUR niche and specific campaign and our exclusive LinkedIn outreach system sending hundreds of direct messages daily.",
  },
  {
    icon: "Bot",
    title: "AI Automation System",
    body: "24/7 AI Voice Agents, Chatbots, Email & SMS Sequences, Social Media Manager, Reputation Manager.",
  },
  {
    icon: "Database",
    title: "Custom CRM System",
    body: "All your leads go directly into your custom built CRM system. Your business follows up instantly.",
  },
];

export const CONVERSION_BENEFITS = [
  { icon: "TrendingDown", label: "Reduced CPL" },
  { icon: "TrendingUp", label: "Higher show-up rates" },
  { icon: "Zap", label: "More qualified conversations" },
  { icon: "LineChart", label: "More closed deals" },
  { icon: "Timer", label: "Faster ROI" },
];

export const TARGET_INDUSTRIES = [
  "Agencies",
  "Financial Advisors",
  "Insurance Firms",
  "Medical & Dental Practices",
  "Real Estate & Investment Firms",
  "B2B Service Providers",
  "Coaches",
  "High-Ticket Offer Businesses",
  "B2C Businesses",
  "eCommerce",
];

export const AUDIENCE_BUILDER = [
  {
    icon: "Fingerprint",
    title: "Target with Intent + Identity",
    body: "Fuse live buying signals with our unified B2B & B2C identity graph to uncover in-market buyers across 30,000+ categories. Reach real decision-makers when they're actively searching — not months later.",
  },
  {
    icon: "Infinity",
    title: "Audiences Without Limits",
    body: "We will build your audiences of any scale instantly. Get real-time counts, automatic deduplication, and clean, activation-ready segments — no manual cleanup required, we handle it all for you.",
  },
  {
    icon: "Filter",
    title: "Smart, Multi-Layer Filtering",
    body: "Go beyond basic targeting. Segment by Firmographics, Demographics, Technographics, Geography, Recency & frequency, Behavioral signals, and Custom intent triggers.",
  },
  {
    icon: "Send",
    title: "Instant Multi-Channel Activation",
    body: "We'll deploy custom audiences directly to Google, Meta, LinkedIn, The Trade Desk, and more. Then we'll build your custom lead generation sales funnel to generate high intent leads consistently.",
  },
  {
    icon: "Shield",
    title: "Built for Privacy & Compliance",
    body: "Designed with privacy-first architecture: Opt-out honoring, Hashed identifiers, Secure clean-room environments, Regulation-ready infrastructure. Performance without compromising trust.",
  },
  {
    icon: "Globe",
    title: "The Entire U.S. Adult Market",
    body: "Tap into hundreds of millions of consumer and business profiles, each layered with real buying signals. Identify exactly who your audience is, where they are, and when they're ready to act.",
  },
];

export const VISITOR_PILLARS = [
  {
    icon: "Eye",
    title: "Visitor Identification",
    body: "Instantly uncover the people and companies browsing your site — and turn missed traffic into qualified opportunities.",
  },
  {
    icon: "BrainCircuit",
    title: "Behavioral Intelligence",
    body: "Transform anonymous website traffic into real, actionable intelligence with identity resolution and behavioral insights.",
  },
  {
    icon: "Megaphone",
    title: "Automated Campaigns",
    body: "Deploy intelligence across direct mail, paid ads, and email campaigns automatically with AI-powered automation.",
  },
  {
    icon: "BadgeDollarSign",
    title: "Revenue Conversion",
    body: "Your marketing stops guessing and starts converting with real-time data and instant follow-up.",
  },
];

export const VISITOR_FEATURES = [
  {
    icon: "UserSearch",
    title: "Identify Visitors Instantly",
    body: "Reveal who is visiting your website the moment they arrive. Transform anonymous traffic into enriched profiles with verified data and insights.",
  },
  {
    icon: "Star",
    title: "Intelligent Prospect Scoring",
    body: "Automatically identify your most valuable prospects using firmographic, demographic, and real-time intent signals.",
  },
  {
    icon: "Rocket",
    title: "Activate Audiences Immediately",
    body: "Send identified visitors directly into your marketing ecosystem—sync audiences to your ads, CRM, and email platforms with a single click.",
  },
  {
    icon: "Lock",
    title: "Privacy-First & Compliant",
    body: "Protect user privacy while gaining insights. Our system honors opt-outs, uses hashed identifiers, and follows regional data compliance standards.",
  },
  {
    icon: "FilterX",
    title: "Smart Traffic Filtering",
    body: "Eliminate wasted marketing spend by filtering out bots, existing customers, and internal traffic so your campaigns target only new opportunities.",
  },
  {
    icon: "PieChart",
    title: "Revenue Attribution",
    body: "Connect conversions back to identified website visitors to clearly measure campaign performance and prove true ROI.",
  },
];

export const STATS = [
  { value: "90%", label: "Buyer Match Accuracy" },
  { value: "<60s", label: "AI Response Time" },
  { value: "30K+", label: "Intent Categories" },
  { value: "24/7", label: "Automated Follow-up" },
];

export const FUTURE_POINTS = [
  "Leverage real-time behavioral data",
  "Automate 90% of follow-up",
  "Own their funnel end-to-end",
  "Remove human bottlenecks",
];

export const PAIN_POINTS = [
  "Cold leads",
  "No-shows",
  "Inconsistent pipelines",
  'Agencies that "test and learn" with your money',
];

export const MEDIA = {
  heroDashboard: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?auto=format&fit=crop&w=1600&q=70",
  team: "https://images.unsplash.com/photo-1758518731706-be5d5230e5a5?auto=format&fit=crop&w=1400&q=70",
  dashboard: "https://images.unsplash.com/photo-1666875753105-c63a6f3bdc86?auto=format&fit=crop&w=1400&q=70",
  aiNetwork: "https://images.pexels.com/photos/17483870/pexels-photo-17483870.png?auto=compress&w=1400",
  meeting: "https://images.unsplash.com/photo-1758691736424-4b4273948341?auto=format&fit=crop&w=1600&q=70",
  videoEmbed: "https://www.youtube.com/embed/aircAruvnKk?rel=0&modestbranding=1",
};

export const TRUSTED_BY = [
  "Northwave Capital",
  "Atlas Realty",
  "Beacon Insurance",
  "Helix Health",
  "Vector Labs",
  "Summit Advisors",
  "Quantum eCom",
  "Pinnacle Group",
];

export const FOOTER_LINKS = {
  Product: ["Audience Builder", "Visitor ID", "AI Automation", "CRM"],
  Solutions: [
    "Financial Advisors",
    "Insurance",
    "Real Estate",
    "Agencies",
    "eCommerce",
  ],
  Company: ["About", "Case Studies", "Careers", "Contact"],
  Legal: ["Privacy Policy", "Terms of Service", "Compliance"],
};
